import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';






import { NavbarModule } from 'app/layout/components/navbar/navbar.module';

import { ToolbarModule } from 'app/layout/components/toolbar/toolbar.module';


import { VerticalLayout1Component } from 'app/layout/vertical/layout-1/layout-1.component';

@NgModule({
    imports: [
    RouterModule,
    NavbarModule,
    ToolbarModule,
    VerticalLayout1Component
],
    exports: [
        VerticalLayout1Component
    ]
})
export class VerticalLayout1Module
{
}